exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".alc-status-indicator{background-color:#fff;border-radius:50%;line-height:0;z-index:2}@media (prefers-color-scheme: dark){:root:not([data-theme=light]):not([data-theme=dark]) .alc-status-indicator{background-color:#000}}:root[data-theme=dark] .alc-status-indicator{background-color:#000}.alc-status-indicator--owned svg{color:green}\n", ""]);

// exports
exports.locals = {
	"alc-status-indicator": "alc-status-indicator",
	"alc-status-indicator--owned": "alc-status-indicator--owned"
};